import { render, staticRenderFns } from "./ModalIncompleteEvidence.vue?vue&type=template&id=b55ca01e&scoped=true&"
import script from "./ModalIncompleteEvidence.vue?vue&type=script&lang=js&"
export * from "./ModalIncompleteEvidence.vue?vue&type=script&lang=js&"
import style0 from "./ModalIncompleteEvidence.vue?vue&type=style&index=0&id=b55ca01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55ca01e",
  null
  
)

export default component.exports